import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factor-rules/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FACTOR_RULES }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FACTOR_RULES, permission: Permission.CREATE }) ||
      !!context.userPermissions.isInternalRole;
    context.validatePermissions({ isAllowed, preload });
  },
});
